import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface FilterCountState {
  value: number;
}

const initialState: FilterCountState = { value: 0 };

export const filterCountSlice = createSlice({
  name: 'filterCount',
  initialState,
  reducers: {
    setFilterCount: (state: FilterCountState, action: PayloadAction<number>) => {
      state.value = action.payload;
    },
  },
});

export const selectedFilterCount = (state: RootState) => state.filterCount.value;

export const { setFilterCount } = filterCountSlice.actions;

export default filterCountSlice.reducer;
